/**
 * Convert [Variable Name] text patterns to Blot HTML for Quill rendering.
 * Called when setting content into the editor.
 */
export function variablesToBlotHtml(html: string): string {
    if (!html) return html;
    return html.replace(/\[([A-Za-z][^\[\]]*?)\]/g, (_match, varName: string) => {
        return `<span class="ql-template-variable" data-variable="${varName}" contenteditable="false">[${varName}]</span>`;
    });
}

/**
 * Convert Blot HTML back to [Variable Name] text format.
 * Called when reading content from the editor to pass to parent/API.
 */
export function blotHtmlToVariables(html: string): string {
    if (!html) return html;
    return html.replace(
        /<span[^>]*class="ql-template-variable"[^>]*data-variable="([^"]*)"[^>]*>\[.*?\]<\/span>/g,
        (_match, varName: string) => `[${varName}]`,
    );
}
